import { SignedIn, SignedOut } from "@clerk/clerk-react";
import { createFileRoute, Link, Outlet } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/_auth")({
	component: Auth,
});

function Auth() {
	const { t } = useTranslation();

	return (
		<>
			<SignedIn>
				<Outlet />
			</SignedIn>
			<SignedOut>
				<div className="min-h-screen bg-base-100 flex items-center justify-center p-4">
					<div className="w-full max-w-md mx-auto">
						<div className="card bg-base-100 shadow-xl">
							<div className="card-body items-center text-center">
								<h1 className="card-title text-2xl">{t("common.signInRequired")}</h1>
								<p className="text-base-content/70">{t("common.signInRequiredDescription")}</p>
								<div className="card-actions mt-4 flex-col gap-2 w-full">
									<Link to="/sign-in" className="btn btn-primary w-full">
										{t("common.signIn")}
									</Link>
									<p className="text-sm text-base-content/60">{t("common.dontHaveAccount")}</p>
									<Link to="/sign-up" className="btn btn-outline w-full">
										{t("common.signUp")}
									</Link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</SignedOut>
		</>
	);
}
